const isLocationForFirstLoadedPage = (locationKey: string, navigationType: string) => {
  return navigationType !== 'PUSH' && locationKey === 'default';
};

export default isLocationForFirstLoadedPage;
